module.exports = vendor_ae494535414d127505aa;


//////////////////
// WEBPACK FOOTER
// external "vendor_ae494535414d127505aa"
// module id = tUwv
// module chunks = 13